// Tables Style Plugin
export default {
    id: 'tables',
    label: 'Tables',
    icon: 'Table',
    properties: {
        borderCollapse: {
            label: 'Border Collapse',
            type: 'select',
            options: ['collapse', 'separate'],
            default: 'separate',
            toClass: (value) => value ? `border-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^border-(collapse|separate)$/);
                return match ? match[1] : null;
            }
        },
        borderSpacing: {
            label: 'Border Spacing',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8'],
            default: '0',
            toClass: (value) => value ? `border-spacing-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^border-spacing-(.+)$/);
                return match ? match[1] : null;
            }
        },
        tableLayout: {
            label: 'Layout',
            type: 'select',
            options: ['auto', 'fixed'],
            default: 'auto',
            toClass: (value) => value ? `table-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^table-(auto|fixed)$/);
                return match ? match[1] : null;
            }
        },
        captionSide: {
            label: 'Caption Side',
            type: 'select',
            options: ['top', 'bottom'],
            default: 'top',
            toClass: (value) => value ? `caption-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^caption-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
